import { createIcon } from '@chakra-ui/react';

export const Facebook = createIcon({
  displayName: 'Facebook',
  viewBox: '0 0 64 64',
  path: (
    <>
      <ellipse
        id="Ellipse_4"
        data-name="Ellipse 4"
        cx="32.001"
        cy="31.439"
        rx="32.001"
        ry="31.439"
        fill="#1777f1"
      />
      <path
        id="Path_2101"
        data-name="Path 2101"
        d="M326.127-796.885l1.338-8.724h-8.37v-5.661c0-2.387,1.169-4.713,4.918-4.713h3.806v-7.427a46.421,46.421,0,0,0-6.756-.589c-6.894,0-11.4,4.178-11.4,11.742v6.649H302v8.724h7.663v21.09a30.4,30.4,0,0,0,4.716.367c1.6,0,3.179,1.15,4.716.909v-22.366h7.032"
        transform="translate(-283.817 838.487)"
        fill="#fff"
      />
    </>
  ),
});
